import { Component, Input, OnInit, inject } from "@angular/core";
import { AdvEffDataService } from "../../shared/services";
import { EffectivenessConclusionsModel, EffectivenessModel } from "../../shared/models";
import { FinalConclusion } from "../status-components/components/eff-final-conclusion-box/models/final-conclusion.model";
import { TranslocoPipe } from "@jsverse/transloco";
import { EffFinalConclusionBoxComponent } from "../status-components/components/eff-final-conclusion-box/eff-final-conclusion-box.component";

@Component({
    selector: "eff-detail-final-conclusion",
    templateUrl: "./eff-detail-final-conclusion.component.html",
    styleUrls: ["./eff-detail-final-conclusion.component.scss"],
    imports: [TranslocoPipe, EffFinalConclusionBoxComponent]
})
export class EffDetailFinalConclusionComponent implements OnInit {
    private _ds = inject(AdvEffDataService);

    @Input() effectivenessModel: EffectivenessModel;

    conclusions: EffectivenessConclusionsModel;

    testerFinalConclusion: FinalConclusion;
    reviewerFinalConclusion: FinalConclusion;

    ngOnInit() {
        this._ds.getConclusions(this.effectivenessModel.guid).subscribe((conclusions) => {
            this.conclusions = conclusions;
            this.testerFinalConclusion = {
                author: conclusions.testerName,
                conclusion: conclusions.testerComment,
                authorLabelKey: "controls.effWorkflowRoles.tester",
                scoreName: conclusions.testerScore,
                scoreColor: conclusions.testerScoreColor,
            };

            if (conclusions.reviewerName) {
                this.reviewerFinalConclusion = {
                    author: conclusions.reviewerName,
                    conclusion: conclusions.reviewerComment,
                    authorLabelKey: "controls.effWorkflowRoles.reviewer",
                    scoreName: conclusions.reviewerScore,
                    scoreColor: conclusions.reviewerScoreColor,
                };
            }
        });
    }
}
